import Image from 'next/image';
import { ImageWrapper } from './styles';
import { imageUrlBuilder } from '@/utils/helpers';

type Asset = {
  asset: {
    _ref: string;
    _type: string;
  };
};

type ImgObject = {
  url: string;
  aspectRatio: number;
  width: number;
};

interface ImageProps {
  width?: number;
  height?: number;
  image: Asset | ImgObject;
  className?: string;
  layout?: 'intrinsic' | 'fixed' | 'responsive';
  props?: unknown;
  alt: string;
  priority?: boolean;
  sizes?: string;
}

function isAsset(img: Asset | ImgObject): img is Asset {
  return (img as Asset).asset !== undefined;
}

const ImageComponent: React.FC<ImageProps> = ({
  image,
  className = '',
  width,
  height,
  layout = 'intrinsic',
  alt,
  priority = false,
  sizes,
  ...props
}) => {
  let url = '';
  let aspectRatio = 1;
  let imgWidth = width;

  if (isAsset(image)) {
    const [, , dimensionString] = image.asset._ref.split('-');
    const [imgWidthStr, imgHeightStr] = dimensionString.split('x');
    aspectRatio = Number(imgWidthStr) / Number(imgHeightStr);
    imgWidth = width || Number(imgWidthStr);
    url = imageUrlBuilder.image(image.asset).width(imgWidth).auto('format').quality(80).url();
  } else {
    aspectRatio = image.aspectRatio;
    url = image.url;
    imgWidth = width || image.width;
  }

  return (
    <ImageWrapper className={className} {...props}>
      <Image
        src={url}
        alt={alt}
        key={url}
        width={imgWidth}
        height={height || imgWidth / aspectRatio}
        layout={layout}
        priority={priority}
        sizes={sizes}
        // @ts-expect-error — fetchpriority not in Next.js 12 types but passes through to <img>
        fetchpriority={priority ? 'high' : undefined}
      />
    </ImageWrapper>
  );
};

export default ImageComponent;
